// Automatically removes the 'sortBy' query parameter from the URL when it changes.
(function () {
  const URL_OBSERVER_LIFETIME_MS = 2000;
  let lastUrl = location?.href;

  function handleUrlChange() {
    if (location?.href !== lastUrl) {
      lastUrl = location.href;
      removeSortByParam();
    }
  }

  function removeSortByParam() {
    try {
      if (typeof window !== "undefined" && window.location?.href) {
        const url = new URL(window.location.href);
        if (url.searchParams?.has("sortBy")) {
          url.searchParams.delete("sortBy");
          const cleanUrl = `${url.pathname}${url.search}${url.hash}`;
          window.history?.replaceState?.(null, "", cleanUrl);
        }
      }
    } catch (error) {
      console.error("Error removing sortBy param:", error);
    }
  }

  if (typeof MutationObserver !== "undefined" && location?.href) {
    const urlObserver = new MutationObserver(handleUrlChange);
    urlObserver.observe(document, { subtree: true, childList: true });
    window?.addEventListener?.("popstate", removeSortByParam);
    setTimeout(() => {
      urlObserver.disconnect?.();
    }, URL_OBSERVER_LIFETIME_MS);
  }
})();

window.addEventListener("DOMContentLoaded", () => {
  const description = document.querySelector(".fp-collection-list__description");
  const moreButton = document.querySelector(".fp-truncate-text-toggle--more");
  const lessButton = document.querySelector(".fp-truncate-text-toggle--less");

  if (!description || !moreButton || !lessButton) return;

  // The description can render more than one <p> (e.g. an empty/whitespace leading
  // paragraph). Use the first one that actually has text so measurements aren't
  // taken on an empty element.
  const paragraphs = [...description.querySelectorAll("p")];
  const paragraph = paragraphs.find((p) => p.textContent.trim().length > 0) || paragraphs[0];
  if (!paragraph) return;

  const CLAMP_LINE_COUNT = 2;
  const LINK_HIDE_CHAR_LIMIT = 235;
  const FALLBACK_LINE_HEIGHT_RATIO = 1.2;
  const HEIGHT_TOLERANCE_PX = 1;
  const OFFSCREEN_OFFSET_PX = -99999;

  // Clamp / un-clamp the paragraph with inline styles so the state can't be
  // overridden by any stylesheet, specificity, or load-timing issue.
  const applyClamp = () => {
    paragraph.style.setProperty("display", "-webkit-box");
    paragraph.style.setProperty("-webkit-box-orient", "vertical");
    paragraph.style.setProperty("-webkit-line-clamp", String(CLAMP_LINE_COUNT));
    paragraph.style.setProperty("overflow", "hidden");
  };
  const removeClamp = () => {
    paragraph.style.setProperty("display", "block");
    paragraph.style.setProperty("-webkit-line-clamp", "unset");
    paragraph.style.setProperty("max-height", "none");
    paragraph.style.setProperty("overflow", "visible");
  };

  // Hide links that fall past the truncation point while the text is clamped.
  const updateLinkVisibility = (isClamped) => {
    let textLength = 0;
    paragraph.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        textLength += (node.textContent || "").length;
      }
      if (node.nodeName === "A") {
        node.style.visibility = isClamped && textLength > LINK_HIDE_CHAR_LIMIT ? "hidden" : "initial";
      }
    });
  };

  // Use a "clone" paragraph to see if the description is long enough to be clamped
  const needsClamping = () => {
    const style = getComputedStyle(paragraph);
    const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * FALLBACK_LINE_HEIGHT_RATIO;
    const width = paragraph.getBoundingClientRect().width;

    const clone = paragraph.cloneNode(true);
    clone.removeAttribute("style");
    clone.style.cssText = [
      "position: fixed",
      "left: " + OFFSCREEN_OFFSET_PX + "px",
      "top: 0",
      "width: " + width + "px",
      "box-sizing: border-box",
      "display: block",
      "-webkit-line-clamp: none",
      "max-height: none",
      "height: auto",
      "overflow: visible",
      "visibility: hidden",
      "pointer-events: none",
    ].join(";");

    paragraph.parentNode.appendChild(clone);
    const fullHeight = clone.getBoundingClientRect().height;
    clone.remove();

    return fullHeight > lineHeight * CLAMP_LINE_COUNT + HEIGHT_TOLERANCE_PX;
  };

  const collapse = () => {
    applyClamp();
    moreButton.classList.remove("hidden");
    moreButton.ariaHidden = "false";
    moreButton.ariaExpanded = "false";
    lessButton.classList.add("hidden");
    lessButton.ariaHidden = "true";
    updateLinkVisibility(true);
  };

  const expand = () => {
    removeClamp();
    moreButton.classList.add("hidden");
    moreButton.ariaHidden = "true";
    lessButton.classList.remove("hidden");
    lessButton.ariaHidden = "false";
    lessButton.ariaExpanded = "true";
    updateLinkVisibility(false);
  };

  const hideToggle = () => {
    removeClamp();
    moreButton.classList.add("hidden");
    moreButton.ariaHidden = "true";
    lessButton.classList.add("hidden");
    lessButton.ariaHidden = "true";
    updateLinkVisibility(false);
  };

  moreButton.addEventListener("click", expand);
  lessButton.addEventListener("click", collapse);

  // On load and on every screen-size change: check to see if we need
  // the "Read more" button
  const refresh = () => {
    if (needsClamping()) collapse();
    else hideToggle();
  };

  // Initial measure, plus a re-measure on load to catch late-loading fonts that
  // change text metrics (and therefore wrapping) at the same width.
  requestAnimationFrame(refresh);
  window.addEventListener("load", refresh);

  // Whether the description needs clamping depends only on its width, so ignore
  // resize events that don't change it (e.g. vertical-only resizes).
  let resizeRaf;
  let lastWidth = description.clientWidth;
  window.addEventListener("resize", () => {
    const width = description.clientWidth;
    if (width === lastWidth) return;
    lastWidth = width;
    cancelAnimationFrame(resizeRaf);
    resizeRaf = requestAnimationFrame(refresh);
  });
});

window.addEventListener("beforeunload", function () {
  sessionStorage.setItem("plpScroll", window.scrollY);
});

window.addEventListener("load", function () {
  const savedScroll = sessionStorage.getItem("plpScroll");
  if (savedScroll !== null) {
    window.scrollTo(0, parseInt(savedScroll, 10));
    sessionStorage.removeItem("plpScroll");
  }
});
